import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'

import isEditorValueEmpty from '@slite/editor/lib/plugins/utils/isEditorValueEmpty'

import { getActiveNote } from 'data/notes/selectors'
import { currentUserCanEditNote } from 'data/rights/selectors'

import { Button } from 'components/base'
import { TemplateIcon } from 'components/Utils/Icons'
import { TEMPLATE_PICKER } from 'components/Utils/Modal/constants'

export default ({ setActiveModal }) => {
  function LaunchPicker({ editor, children }) {
    const isEditorEmpty = isEditorValueEmpty(editor.value)
    // Prevent display for notes with children or archived notes
    const activeNote = useSelector(getActiveNote)
    const canEdit = useSelector(state =>
      currentUserCanEditNote(state, activeNote)
    )
    const displayLauncher =
      isEditorEmpty && activeNote && !activeNote.hasChildren && canEdit

    return (
      <Fragment>
        {children}
        {displayLauncher && (
          <div
            className="margin-top-largest shade-20"
            style={{ fontSize: 14, marginBottom: 120 }}
          >
            <Button.Tertiary
              onClick={() => setActiveModal({ id: TEMPLATE_PICKER })}
              slim
              style={{ width: 'fit-content', marginLeft: -12 }}
              className="margin-bottom-medium"
            >
              <div className="margin-right-small flexbox flexbox-align-center">
                <TemplateIcon size={12} />
              </div>
              Use a template
            </Button.Tertiary>
          </div>
        )}
      </Fragment>
    )
  }

  return {
    renderEditor(props, editor, next) {
      return <LaunchPicker editor={editor}>{next()}</LaunchPicker>
    },
  }
}
